<script lang="ts">
    import MedialibImage from "../MedialibImage.svelte"
    import { apiBaseOverride } from "../../store"

    export let apiBase: string = null
    if (apiBase) $apiBaseOverride = apiBase

    export let slide: BlockContentSlide
</script>

<!-- is admin view or not hidden -->
{#if apiBase || !slide.hide}
    <div class="slide vp-l" class:hidden="{!!slide.hide}">
        <div class="slide-content">
            {#if slide.headline}
                <header>
                    <div class="headline" class:centered="{slide.centerHeadline}">
                        <h3>{@html slide.headline}</h3>
                    </div>
                </header>
            {/if}

            {#if slide.image}
                <div class="background-image vp-m">
                    <figure>
                        <MedialibImage id="{slide.image}" />
                    </figure>
                </div>
            {/if}

            {#if slide.text}
                <div class="text">
                    {@html slide.text}
                </div>
            {/if}
        </div>
    </div>
{/if}

<style lang="less">
    .hidden {
        opacity: 0.5 !important;
        filter: grayscale(100%);
    }
</style>
